/* The API server uses base62-encoded UUIDs as resource identifiers.  The function b62encode is a port
of python code used by the API server, to ensure interoperability.
*/

function b62encode(value: bigint) {
  if (value < BigInt(0)) {
    throw new Error('Negative ints cannot be base62-encoded.')
  }
  const alphabet = Array.from(
    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
  )
  const base = BigInt(62)
  let x = value
  let b62_repr = ''
  while (x) {
    ;[x, b62_repr] = [x / base, alphabet[Number(x % base)] + b62_repr]
  }
  return b62_repr || '0'
}

export type ResourceId = string

export function newResourceId() {
  const uuidData = crypto.randomUUID().replaceAll('-', '')
  const value = BigInt(`0x${uuidData}`)
  return b62encode(value) as ResourceId
}
